<div class="listingFacets_facets" *ngIf="(facets || (framesSizes | json) !== '{}') && breakpoint$ | async">
  <div class="listingFacets_facet-container" [ngClass]="{'-active': selectedMobile === 'filters'}">
    <v-frames-size-filter  *ngIf="(framesSizes | json) !== '{}'" [facets]="framesSizes" (submitFacets)="filterFromSizes($event)"
                           [themePath]="themePath" [breakpoint$]="breakpoint$" [processing]="processing">
    </v-frames-size-filter>
    <v-facet *ngFor="let facet of facets" [facet]="facet" [breakpoint$]="breakpoint$" [processing]="processing"
             [showSearch]="facet.code === 'brandName'" (submitFacets)="clickFacet($event)" (closeFacets)="showFacetsMobile('filters')">
    </v-facet>
    <div class="listingFacets_facet-container_clear" *ngIf="selected.length && selectedMobile === 'filters'">
      <button type="button"  (click)="resetFilters()" [disabled]="processing" class="listingFacets_clearButton">
        {{'listing.facets.clear' | translate}}
      </button>
    </div>
  </div>
  <nav class="listingFacets_mobileNav">
    <button type="button" [ngClass]="{'flaticon-down-arrow -selected': selectedMobile === 'filters'}" (click)="showFacetsMobile('filters')">
      {{'listing.facets.mobile.filters' | translate}} <span *ngIf="selectedCount > 0">({{selectedCount}})</span>
    </button>
    <button type="button" [ngClass]="{'flaticon-down-arrow -selected': selectedMobile === 'sort'}" (click)="showFacetsMobile('sort')">
      {{'listing.facets.mobile.sort' | translate}}
    </button>
  </nav>
  <footer class="listingFacets_footer" *ngIf="selectedCount > 0">
    <ul class="listingFacets_selected">
      <li *ngIf="selectedSizes[selectedFacetWithLabel.lensWidth]">
        <div class="listingFacets_selectedSizes" [ngClass]="{'-disabled': processing}">
          <b>{{selectedSizes[selectedFacetWithLabel.lensWidth][0].facetName}}</b>
          <button [disabled]="processing" class="listingFacets_selectedSizeButton flaticon-close" *ngFor="let sel of selectedSizes[selectedFacetWithLabel.lensWidth]" (click)="removeAndFilter(sel.facetCode+'-'+sel.facetValueCode, sel.facetWebname, sel.facetValueCode)">{{sel.facetValueCode}}</button>
        </div>
      </li>
      <li *ngIf="selectedSizes[selectedFacetWithLabel.noseSize]">
        <div class="listingFacets_selectedSizes" [ngClass]="{'-disabled': processing}">
          <b>{{selectedSizes[selectedFacetWithLabel.noseSize][0].facetName}}</b>
          <button [disabled]="processing" class="listingFacets_selectedSizeButton flaticon-close" *ngFor="let sel of selectedSizes[selectedFacetWithLabel.noseSize]" (click)="removeAndFilter(sel.facetCode+'-'+sel.facetValueCode, sel.facetWebname, sel.facetValueCode)">{{sel.facetValueCode}}</button>
        </div>
      </li>
      <li *ngIf="selectedSizes[selectedFacetWithLabel.framesSize]">
        <div class="listingFacets_selectedSizes" [ngClass]="{'-disabled': processing}">
          <b>{{selectedSizes[selectedFacetWithLabel.framesSize][0].facetName}}</b>
          <button [disabled]="processing" class="listingFacets_selectedSizeButton flaticon-close" *ngFor="let sel of selectedSizes[selectedFacetWithLabel.framesSize]" (click)="removeAndFilter(sel.facetCode+'-'+sel.facetValueCode, sel.facetWebname, sel.facetValueCode)">{{sel.facetValueCode}}</button>
        </div>
      </li>
      <li *ngFor="let sel of selected" >
        <button [disabled]="processing" (click)="removeAndFilter(sel.facetCode+'-'+sel.facetValueCode, sel.facetWebname, sel.facetValueCode)" class="listingFacets_selectedButton flaticon-close">
          <b *ngIf="sel.facetCode === selectedFacetWithLabel.flexibleTemples
          || sel.facetCode === selectedFacetWithLabel.caseIncluded|| sel.facetCode === selectedFacetWithLabel.isColored
          || sel.facetCode === selectedFacetWithLabel.polarize || sel.facetCode === selectedFacetWithLabel.prescription
          || sel.facetCode === selectedFacetWithLabel.gradial || sel.facetCode === selectedFacetWithLabel.mirrored
          || sel.facetCode === selectedFacetWithLabel.vtoReady || sel.facetCode === selectedFacetWithLabel.framesSize
          || sel.facetCode === selectedFacetWithLabel.noseSize || sel.facetCode === selectedFacetWithLabel.lensWidth">
            {{sel.facetName}}</b> {{sel.facetValueName| title}}
        </button>
      </li>
    </ul>
    <button type="button" (click)="resetFilters()" [disabled]="processing" class="listingFacets_clearButton">
      {{'listing.facets.clear' | translate}}
    </button>
  </footer>
</div>
